import { css } from "lit";

export const dropdownMenuItemStyles = css`
  :host {
    display: block;
  }

  .dropdown-menu-item {
    display: flex;
    align-items: center;
    gap: var(--sds-size-space-300);
    width: 100%;
    padding: var(--sds-size-space-300) var(--sds-size-space-400);
    background: none;
    border: none;
    border-radius: var(--sds-size-radius-200);
    cursor: pointer;
    font-family: inherit;
    font-size: var(--sds-typography-scale-02);
    line-height: 1.4;
    color: var(--sds-color-text-default-default);
    text-align: left;
    transition: background-color 0.15s ease;
    min-height: 32px;
  }

  .dropdown-menu-item:hover:not(:disabled) {
    background-color: var(--sds-color-background-neutral-secondary);
  }

  .dropdown-menu-item:focus-visible {
    outline: var(--sds-size-stroke-focus-ring) solid var(--sds-color-border-default-default);
    outline-offset: -2px;
    background-color: var(--sds-color-background-neutral-secondary);
  }

  .dropdown-menu-item:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .dropdown-menu-item-label {
    flex: 1;
    white-space: nowrap;
  }

  ::slotted([slot="icon"]) {
    flex-shrink: 0;
    color: grey;
  }

  :host([variant="danger"]) {
    border-top: 1px solid var(--sds-color-border-default-secondary);
    margin-top: var(--sds-size-space-200);
    padding-top: var(--sds-size-space-200);
  }

  :host([variant="danger"]) .dropdown-menu-item {
    color: var(--sds-color-text-danger-default);
  }

  :host([variant="danger"]) ::slotted([slot="icon"]) {
    color: var(--sds-color-text-danger-default);
  }
`;
